module.exports = __webpack_public_path__ + "img/image.e298bc24.png";